import type { Dish } from '@/types/dish';
import { baseDish, t } from './mockCommon';

/**
 * Crée le plat Parmentier de canard (ID: 26 -> Mock ID -1)
 */
function createParmentierDish(): Dish {
  return {
    ...baseDish,
    id: -1,
    name: t('onboarding.mockData.dishes.parmentier.name'),
    difficulty: 3,
    prep_time_min: 25,
    cook_time_min: 35,
    chill_time_min: 0,
    servings: 10,
    selected_image: 'none',
    allergens: `${t('onboarding.mockData.dishes.parmentier.allergens.lactose')}, ${t('onboarding.mockData.dishes.parmentier.allergens.gluten')}`,
    calories_kcal: 540,
    protein_g: 24.0,
    fat_g: 27.0,
    saturated_fat_g: 10.0,
    carbohydrates_g: 48.0,
    sugars_g: 9.0,
    dietary_fiber_g: 7.0,
    salt_sodium_g: 1.6,
    ingredients: [
      //
      { id: 1, category: 'meat', name: t('onboarding.mockData.dishes.parmentier.ingredients.duck'), quantity: 200, unit: 'g', price: 5.32 },
      {
        id: 2,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.sweetPotato'),
        quantity: 250,
        unit: 'g',
        price: 1,
      },
      {
        id: 3,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.potato'),
        quantity: 150,
        unit: 'g',
        price: 0.4,
      },
      { id: 4, category: 'fruits_veggies', name: t('onboarding.mockData.dishes.parmentier.ingredients.onion'), quantity: 30, unit: 'g', price: 0.12 },
      { id: 5, category: 'fruits_veggies', name: t('onboarding.mockData.dishes.parmentier.ingredients.garlic'), quantity: 3, unit: 'g', price: 0.05 },
      {
        id: 6,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.oliveOil'),
        quantity: 5,
        unit: 'ml',
        price: 0.07,
      },
      { id: 7, category: 'dairy', name: t('onboarding.mockData.dishes.parmentier.ingredients.butter'), quantity: 12, unit: 'g', price: 0.25 },
      { id: 8, category: 'dairy', name: t('onboarding.mockData.dishes.parmentier.ingredients.milk'), quantity: 30, unit: 'ml', price: 0.05 },
      { id: 9, category: 'dried_economat', name: t('onboarding.mockData.dishes.parmentier.ingredients.salt'), quantity: 2.5, unit: 'g', price: 0.02 },
      {
        id: 10,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.pepper'),
        quantity: 0.8,
        unit: 'g',
        price: 0.04,
      },
      {
        id: 11,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.parsley'),
        quantity: 2,
        unit: 'g',
        price: 0.1,
      },
      {
        id: 12,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.nutmeg'),
        quantity: 0.2,
        unit: 'g',
        price: 0.04,
      },
      {
        id: 13,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.parmentier.ingredients.breadcrumbs'),
        quantity: 6,
        unit: 'g',
        price: 0.06,
      },
    ],
  };
}

/**
 * Crée le plat Saumon en croûte (ID: 27 -> Mock ID -2)
 */
function createSalmonCrustDish(): Dish {
  return {
    ...baseDish,
    id: -2,
    name: t('onboarding.mockData.dishes.salmonCrust.name'),
    difficulty: 3,
    prep_time_min: 30,
    cook_time_min: 25,
    chill_time_min: 10,
    servings: 10,
    selected_image: 'none',
    allergens: `${t('onboarding.mockData.dishes.salmonCrust.allergens.fish')}, ${t('onboarding.mockData.dishes.salmonCrust.allergens.gluten')}, ${t('onboarding.mockData.dishes.salmonCrust.allergens.egg')}, ${t('onboarding.mockData.dishes.salmonCrust.allergens.lactose')}, ${t('onboarding.mockData.dishes.salmonCrust.allergens.mustard')}`,
    calories_kcal: 605,
    protein_g: 36.0,
    fat_g: 36.0,
    saturated_fat_g: 13.0,
    carbohydrates_g: 37.0,
    sugars_g: 4.0,
    dietary_fiber_g: 6.0,
    salt_sodium_g: 1.8,
    ingredients: [
      //
      { id: 14, category: 'fish', name: t('onboarding.mockData.dishes.salmonCrust.ingredients.salmon'), quantity: 200, unit: 'g', price: 5.6 },
      {
        id: 15,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.brusselsSprouts'),
        quantity: 200,
        unit: 'g',
        price: 1.8,
      },
      {
        id: 16,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.shallot'),
        quantity: 15,
        unit: 'g',
        price: 0.24,
      },
      {
        id: 17,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.garlic'),
        quantity: 3,
        unit: 'g',
        price: 0.05,
      },
      {
        id: 18,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.breadcrumbs'),
        quantity: 15,
        unit: 'g',
        price: 0.16,
      },
      {
        id: 19,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.parsley'),
        quantity: 4,
        unit: 'g',
        price: 0.25,
      },
      {
        id: 20,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.chives'),
        quantity: 2,
        unit: 'g',
        price: 0.18,
      },
      { id: 21, category: 'fruits_veggies', name: t('onboarding.mockData.dishes.salmonCrust.ingredients.dill'), quantity: 3, unit: 'g', price: 0.28 },
      {
        id: 22,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.mustard'),
        quantity: 6,
        unit: 'g',
        price: 0.1,
      },
      {
        id: 23,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.oliveOil'),
        quantity: 20,
        unit: 'ml',
        price: 0.25,
      },
      { id: 24, category: 'dried_economat', name: t('onboarding.mockData.dishes.salmonCrust.ingredients.salt'), quantity: 2, unit: 'g', price: 0.01 },
      {
        id: 25,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.pepper'),
        quantity: 0.8,
        unit: 'g',
        price: 0.05,
      },
      { id: 26, category: 'dairy', name: t('onboarding.mockData.dishes.salmonCrust.ingredients.butter'), quantity: 10, unit: 'g', price: 0.2 },
      {
        id: 27,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.puffPastry'),
        quantity: 120,
        unit: 'g',
        price: 1.3,
      },
      { id: 28, category: 'dairy', name: t('onboarding.mockData.dishes.salmonCrust.ingredients.egg'), quantity: 50, unit: 'g', price: 0.4 },
      {
        id: 29,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.salmonCrust.ingredients.lemonJuice'),
        quantity: 10,
        unit: 'ml',
        price: 0.2,
      },
    ],
  };
}

/**
 * Crée le plat Boulettes de veau (ID: 28 -> Mock ID -3)
 */
function createVealMeatballsDish(): Dish {
  return {
    ...baseDish,
    id: -3,
    name: t('onboarding.mockData.dishes.vealMeatballs.name'),
    difficulty: 3,
    prep_time_min: 25,
    cook_time_min: 35,
    chill_time_min: 0,
    servings: 10,
    selected_image: 'none',
    allergens: `${t('onboarding.mockData.dishes.vealMeatballs.allergens.lactose')}, ${t('onboarding.mockData.dishes.vealMeatballs.allergens.eggs')}, ${t('onboarding.mockData.dishes.vealMeatballs.allergens.gluten')}`,
    calories_kcal: 630,
    protein_g: 34.0,
    fat_g: 27.0,
    saturated_fat_g: 12.0,
    carbohydrates_g: 58.0,
    sugars_g: 3.0,
    dietary_fiber_g: 4.0,
    salt_sodium_g: 2.7,
    ingredients: [
      //
      { id: 30, category: 'meat', name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.veal'), quantity: 120, unit: 'g', price: 2.94 },
      { id: 31, category: 'dairy', name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.parmesan'), quantity: 10, unit: 'g', price: 0.35 },
      { id: 32, category: 'dairy', name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.egg'), quantity: 50, unit: 'g', price: 0.315 },
      {
        id: 33,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.parsley'),
        quantity: 4,
        unit: 'g',
        price: 0.2,
      },
      {
        id: 34,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.chives'),
        quantity: 3,
        unit: 'g',
        price: 0.2,
      },
      {
        id: 35,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.garlic'),
        quantity: 2,
        unit: 'g',
        price: 0.05,
      },
      {
        id: 36,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.onion'),
        quantity: 20,
        unit: 'g',
        price: 0.15,
      },
      {
        id: 37,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.breadcrumbs'),
        quantity: 12,
        unit: 'g',
        price: 0.15,
      },
      {
        id: 38,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.rice'),
        quantity: 50,
        unit: 'g',
        price: 0.45,
      },
      {
        id: 39,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.mushrooms'),
        quantity: 10,
        unit: 'g',
        price: 0.7,
      },
      {
        id: 40,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.shallot'),
        quantity: 10,
        unit: 'g',
        price: 0.25,
      },
      {
        id: 41,
        category: 'alcohol',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.whiteWine'),
        quantity: 30,
        unit: 'ml',
        price: 0.6,
      },
      {
        id: 42,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.broth'),
        quantity: 200,
        unit: 'ml',
        price: 0.25,
      },
      { id: 43, category: 'dairy', name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.butter'), quantity: 15, unit: 'g', price: 0.3 },
      { id: 44, category: 'dairy', name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.cream'), quantity: 20, unit: 'ml', price: 0.25 },
      {
        id: 45,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.oliveOil'),
        quantity: 20,
        unit: 'ml',
        price: 0.4,
      },
      {
        id: 46,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.pepper'),
        quantity: 0.8,
        unit: 'g',
        price: 0.05,
      },
      {
        id: 47,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.salt'),
        quantity: 2,
        unit: 'g',
        price: 0.02,
      },
      {
        id: 48,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.vealMeatballs.ingredients.thyme'),
        quantity: 1,
        unit: 'g',
        price: 0.15,
      },
    ],
  };
}

/**
 * Crée le plat Galette de sarrasin (ID: 29 -> Mock ID -4)
 */
function createBuckwheatPancakeDish(): Dish {
  return {
    ...baseDish,
    id: -4,
    name: t('onboarding.mockData.dishes.buckwheatPancake.name'),
    difficulty: 3,
    prep_time_min: 30,
    cook_time_min: 25,
    chill_time_min: 15,
    servings: 10,
    selected_image: 'none',
    allergens: `${t('onboarding.mockData.dishes.buckwheatPancake.allergens.lactose')}, ${t('onboarding.mockData.dishes.buckwheatPancake.allergens.eggs')}, ${t('onboarding.mockData.dishes.buckwheatPancake.allergens.fish')}`,
    calories_kcal: 520,
    protein_g: 32.0,
    fat_g: 27.0,
    saturated_fat_g: 13.0,
    carbohydrates_g: 34.0,
    sugars_g: 3.0,
    dietary_fiber_g: 4.0,
    salt_sodium_g: 1.7,
    ingredients: [
      //
      {
        id: 49,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.flour'),
        quantity: 50,
        unit: 'g',
        price: 0.5,
      },
      {
        id: 50,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.salt'),
        quantity: 1.5,
        unit: 'g',
        price: 0.03,
      },
      { id: 51, category: 'dairy', name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.milk'), quantity: 50, unit: 'ml', price: 0.12 },
      { id: 52, category: 'dairy', name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.butter'), quantity: 8, unit: 'g', price: 0.16 },
      {
        id: 53,
        category: 'dairy',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.freshCream'),
        quantity: 40,
        unit: 'ml',
        price: 0.38,
      },
      { id: 54, category: 'dairy', name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.eggs'), quantity: 50, unit: 'g', price: 0.5 },
      { id: 55, category: 'fish', name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.salmon'), quantity: 120, unit: 'g', price: 3.08 },
      {
        id: 56,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.spinach'),
        quantity: 80,
        unit: 'g',
        price: 0.8,
      },
      {
        id: 57,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.onions'),
        quantity: 20,
        unit: 'g',
        price: 0.08,
      },
      {
        id: 58,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.lemon'),
        quantity: 20,
        unit: 'g',
        price: 0.24,
      },
      {
        id: 59,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.pepper'),
        quantity: 0.6,
        unit: 'g',
        price: 0.06,
      },
      {
        id: 60,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.nutmeg'),
        quantity: 0.2,
        unit: 'g',
        price: 0.04,
      },
      {
        id: 61,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.buckwheatPancake.ingredients.chives'),
        quantity: 2,
        unit: 'g',
        price: 0.15,
      },
    ],
  };
}

/**
 * Crée le plat Rôti de dinde (ID: 30 -> Mock ID -5)
 */
function createTurkeyRoastDish(): Dish {
  return {
    ...baseDish,
    id: -5,
    name: t('onboarding.mockData.dishes.turkeyRoast.name'),
    difficulty: 3,
    prep_time_min: 40,
    cook_time_min: 60,
    chill_time_min: 0,
    servings: 10,
    selected_image: 'none',
    allergens: `${t('onboarding.mockData.dishes.turkeyRoast.allergens.lactose')}, ${t('onboarding.mockData.dishes.turkeyRoast.allergens.nuts')}, ${t('onboarding.mockData.dishes.turkeyRoast.allergens.gluten')}, ${t('onboarding.mockData.dishes.turkeyRoast.allergens.sulfites')}`,
    calories_kcal: 520,
    protein_g: 38.0,
    fat_g: 20.0,
    saturated_fat_g: 7.0,
    carbohydrates_g: 47.0,
    sugars_g: 18.0,
    dietary_fiber_g: 9.0,
    salt_sodium_g: 2.1,
    ingredients: [
      //
      { id: 62, category: 'meat', name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.turkey'), quantity: 250, unit: 'g', price: 4.55 },
      {
        id: 63,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.apricots'),
        quantity: 15,
        unit: 'g',
        price: 0.5,
      },
      {
        id: 64,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.prunes'),
        quantity: 12,
        unit: 'g',
        price: 0.4,
      },
      {
        id: 65,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.raisins'),
        quantity: 8,
        unit: 'g',
        price: 0.25,
      },
      {
        id: 66,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.walnuts'),
        quantity: 8,
        unit: 'g',
        price: 0.5,
      },
      {
        id: 67,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.onion'),
        quantity: 15,
        unit: 'g',
        price: 0.08,
      },
      {
        id: 68,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.garlic'),
        quantity: 2,
        unit: 'g',
        price: 0.04,
      },
      {
        id: 69,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.carrots'),
        quantity: 100,
        unit: 'g',
        price: 0.25,
      },
      {
        id: 70,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.parsnips'),
        quantity: 70,
        unit: 'g',
        price: 0.35,
      },
      {
        id: 71,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.celeriac'),
        quantity: 60,
        unit: 'g',
        price: 0.32,
      },
      {
        id: 72,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.potatoes'),
        quantity: 120,
        unit: 'g',
        price: 0.28,
      },
      {
        id: 73,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.shallots'),
        quantity: 10,
        unit: 'g',
        price: 0.2,
      },
      {
        id: 74,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.parsley'),
        quantity: 2.5,
        unit: 'g',
        price: 0.1,
      },
      { id: 75, category: 'fruits_veggies', name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.thyme'), quantity: 1, unit: 'g', price: 0.1 },
      {
        id: 76,
        category: 'fruits_veggies',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.rosemary'),
        quantity: 1,
        unit: 'g',
        price: 0.1,
      },
      {
        id: 77,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.breadcrumbs'),
        quantity: 8,
        unit: 'g',
        price: 0.1,
      },
      { id: 78, category: 'dairy', name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.butter'), quantity: 10, unit: 'g', price: 0.2 },
      {
        id: 79,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.oliveOil'),
        quantity: 12,
        unit: 'ml',
        price: 0.2,
      },
      { id: 80, category: 'dried_economat', name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.salt'), quantity: 3, unit: 'g', price: 0.05 },
      {
        id: 81,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.pepper'),
        quantity: 1,
        unit: 'g',
        price: 0.05,
      },
      { id: 82, category: 'alcohol', name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.whiteWine'), quantity: 20, unit: 'ml', price: 0.3 },
      {
        id: 83,
        category: 'dried_economat',
        name: t('onboarding.mockData.dishes.turkeyRoast.ingredients.broth'),
        quantity: 50,
        unit: 'ml',
        price: 0.2,
      },
    ],
  };
}

// Map des factory functions par ID (mise à jour)
export const dishFactories: Record<number, () => Dish> = {
  [-1]: createParmentierDish,
  [-2]: createSalmonCrustDish,
  [-3]: createVealMeatballsDish,
  [-4]: createBuckwheatPancakeDish,
  [-5]: createTurkeyRoastDish,
};

export { createParmentierDish };
